"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
var companyApi = _interopRequireWildcard(require("@/api/merchantStatementCompanyApi"));
var _systemSetting = require("@/api/systemSetting");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ConfirmStatementDialog',
  data: function data() {
    return {
      visible: false,
      submitLoading: false,
      detailLoading: false,
      uploadLoading: false,
      uploadCount: 0,
      companyLoading: false,
      companyList: [],
      labelWidth: '130px',
      mode: 'confirm',
      form: {
        id: '',
        statementNo: '',
        merchantName: '',
        companyId: '',
        merchantFile: '',
        reconciliationRemark: ''
      },
      fileList: [],
      rules: {
        companyId: [{
          required: true,
          message: '请选择打款公司主体',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.mode === 'edit' ? '编辑' : '确认对账单';
    }
  },
  methods: {
    open: function open(row) {
      this.mode = 'confirm';
      this.setFormData(row || {});
      this.visible = true;
      this.loadCompanyList();
    },
    openEdit: function openEdit(row) {
      this.mode = 'edit';
      this.setFormData(row || {});
      this.visible = true;
      this.loadCompanyList();
      this.loadEditDetail(row.id);
    },
    setFormData: function setFormData(row) {
      this.form = {
        id: row.id,
        statementNo: row.statementNo || '',
        merchantName: row.merchantName || '',
        companyId: row.companyId || '',
        merchantFile: row.merchantFile || '',
        reconciliationRemark: row.reconciliationRemark || ''
      };
      this.fileList = this.parseMerchantFiles(this.form.merchantFile);
    },
    handleClose: function handleClose() {
      this.visible = false;
    },
    handleClosed: function handleClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.fileList = [];
      this.uploadCount = 0;
      this.uploadLoading = false;
      this.detailLoading = false;
      this.mode = 'confirm';
    },
    loadEditDetail: function loadEditDetail(id) {
      var _this = this;
      if (!id) return;
      this.detailLoading = true;
      statementApi.statementEditDetailApi(id).then(function (data) {
        _this.setFormData(_objectSpread(_objectSpread(_objectSpread({}, _this.form), data || {}), {}, {
          id: id
        }));
      }).catch(function () {}).finally(function () {
        _this.detailLoading = false;
      });
    },
    handleFileUpload: function () {
      var _handleFileUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(options) {
        var file, formData, isImage, uploadApi, fileResult, currentFiles, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = options.file;
              this.uploadCount += 1;
              this.uploadLoading = true;
              formData = new FormData();
              formData.append('multipart', file);
              isImage = /\.(png|jpe?g|gif|bmp|webp)$/i.test(file.name);
              uploadApi = isImage ? _systemSetting.fileImageApi : _systemSetting.fileFileApi;
              _context.p = 1;
              _context.n = 2;
              return uploadApi(formData, {
                model: this.$route.path.split('/')[1],
                pid: 10
              });
            case 2:
              fileResult = _context.v;
              if (fileResult && fileResult.url) {
                currentFiles = this.fileList.filter(function (item) {
                  return item.url;
                });
                currentFiles.push({
                  name: fileResult.fileName || file.name,
                  url: fileResult.url
                });
                this.fileList = currentFiles;
                this.syncMerchantFile();
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败');
                this.removeUploadFile(file);
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error('上传失败，请重试');
              this.removeUploadFile(file);
            case 4:
              _context.p = 4;
              this.uploadCount = Math.max(this.uploadCount - 1, 0);
              this.uploadLoading = this.uploadCount > 0;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleUploadRemove: function handleUploadRemove(file) {
      var removeUrl = file.url;
      var removeUid = file.uid;
      this.fileList = this.fileList.filter(function (item) {
        if (removeUrl) return item.url !== removeUrl;
        return item.uid !== removeUid;
      });
      this.syncMerchantFile();
    },
    parseMerchantFiles: function parseMerchantFiles(merchantFile) {
      var _this2 = this;
      if (!merchantFile) return [];
      if (Array.isArray(merchantFile)) {
        return merchantFile.filter(Boolean).map(function (url) {
          return {
            name: _this2.getFileName(url),
            url: url
          };
        });
      }
      return String(merchantFile).split(',').map(function (url) {
        return url.trim();
      }).filter(Boolean).map(function (url) {
        return {
          name: _this2.getFileName(url),
          url: url
        };
      });
    },
    syncMerchantFile: function syncMerchantFile() {
      this.form.merchantFile = this.fileList.map(function (item) {
        return item.url;
      }).filter(Boolean).join(',');
    },
    removeUploadFile: function removeUploadFile(file) {
      if (!file) return;
      var removeUid = file.uid;
      this.fileList = this.fileList.filter(function (item) {
        return item.uid !== removeUid && item.raw !== file;
      });
      this.syncMerchantFile();
    },
    getFileName: function getFileName(url) {
      if (!url) return '';
      var fileName = String(url).split('/').pop() || '';
      return decodeURIComponent(fileName.split('?')[0]);
    },
    loadCompanyList: function loadCompanyList() {
      var _this3 = this;
      this.companyLoading = true;
      companyApi.getCompanySimpleList().then(function (data) {
        _this3.companyList = data.list || [];
      }).catch(function () {}).finally(function () {
        _this3.companyLoading = false;
      });
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this4.submitLoading = true;
        statementApi.statementConfirmApi({
          id: _this4.form.id,
          companyId: _this4.form.companyId,
          merchantFile: _this4.form.merchantFile || undefined
        }).then(function () {
          return statementApi.statementReconciliationRemarkApi({
            id: _this4.form.id,
            reconciliationRemark: _this4.form.reconciliationRemark
          });
        }).then(function () {
          _this4.$message.success('确认成功');
          _this4.handleClose();
          _this4.$emit('refresh');
        }).catch(function () {}).finally(function () {
          _this4.submitLoading = false;
        });
      });
    }
  }
};